export enum ActivityType {
    PROJECT_CREATE = "PROJECT_CREATE",
    PROJECT_IMPORT_EXAMPLES = "PROJECT_IMPORT_EXAMPLES",
    PROJECT_CREATE_FIELD = "PROJECT_CREATE_FIELD",
    PROJECT_CREATE_TEMPLATE = "PROJECT_CREATE_TEMPLATE",
    PROJECT_CREATE_CLASSIFICATION = "PROJECT_CREATE_CLASSIFICATION",
    PROJECT_START_FINE_TUNE = "PROJECT_START_FINE_TUNE",
    INTEGRATION_UPDATE = "INTEGRATION_UPDATE",
}